import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AppLayout from "../layout/AppLayout";
import SchoolExamPayment from "../pages/exams/SchoolExamPayment";
import SchoolExamReports from "../pages/reports/SchoolExamReports";
import SchoolExamPayments from "../pages/exams/SchoolExamPayments";
import SubjectRegistrations from "../pages/exams/SubjectRegistrations";
import NewSubjectRegistrations from "../pages/exams/NewSubjectRegistrations";

const School = lazy(() => import("../pages/schools/School"));
const ExamRegistrations = lazy(
  () => import("../pages/exams/ExamRegistrations")
);
const NewExamRegistration = lazy(
  () => import("../pages/exams/NewExamRegistration")
);
const SchoolDashboard = lazy(
  () => import("../pages/dashboard/SchoolDashboard")
);
const Profile = lazy(() => import("../pages/users/Profile"));
const ExamRegistrationForms = lazy(() => import("../pages/exams/ExamRegistrationForms"));
const PastExamQuestions = lazy(() => import("../pages/exams/PastExamQuestions"));
const SchemesOfWork = lazy(() => import("../pages/exams/SchemesOfWork"));

// Import NotFound component
const NotFound = lazy(() => import("../pages/errors/NotFound"));

// Loading component for Suspense fallback
const LoadingFallback = () => (
  <div className="flex items-center justify-center h-full">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500"></div>
  </div>
);

const SchoolAdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AppLayout />}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route
          path="dashboard"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <SchoolDashboard />
            </Suspense>
          }
        />

        <Route
          path="profile"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Profile />
            </Suspense>
          }
        />

        <Route path="school" element={<School />} />
        <Route path="reports" element={<SchoolExamReports />} />

        <Route path="exams">
          <Route index element={<ExamRegistrations />} />
          <Route path="new" element={<NewExamRegistration />} />
          <Route path=":id/edit" element={<NewExamRegistration />} />
          <Route path="subjects" element={<SubjectRegistrations />} />
          <Route
            path="subjects/new/:examRegistrationId"
            element={<NewSubjectRegistrations />}
          />
          <Route path="registration-forms" element={<ExamRegistrationForms />} />
          <Route path="past-exam-questions" element={<PastExamQuestions />} />
          <Route path="schemes-of-work" element={<SchemesOfWork />} />
        </Route>

        <Route path="payments">
          <Route index element={<SchoolExamPayments />} />
          <Route path=":id" element={<SchoolExamPayment />} />
        </Route>

        {/* Catch-all route for super-admin section - redirects to NotFound */}
        <Route
          path="*"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <NotFound />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
};

export default SchoolAdminRoutes;
